import { supabase } from '@/lib/supabase';

export class SupabaseAuthService {
  private checkSupabase() {
    if (!supabase) {
      throw new Error('Serviço de autenticação não disponível. Por favor, tente novamente mais tarde.');
    }
    return supabase;
  }

  async requestMagicLink(email: string, redirectTo: string): Promise<void> {
    const client = this.checkSupabase();
    const { error } = await client.auth.signInWithOtp({
      email,
      options: {
        emailRedirectTo: redirectTo,
      },
    });

    if (error) {
      throw new Error(error.message || 'Failed to send magic link');
    }
  }

  async verifyMagicLinkToken(
    email: string,
    token: string,
    type: string,
  ): Promise<void> {
    const client = this.checkSupabase();
    const { error } = await client.auth.verifyOtp({
      email,
      token,
      type: type as any,
    });

    if (error) {
      throw new Error(error.message || 'Invalid or expired magic link');
    }
  }

  async getSession() {
    const client = this.checkSupabase();
    return client.auth.getSession();
  }

  async exchangeCodeForSession(code: string) {
    const client = this.checkSupabase();
    return client.auth.exchangeCodeForSession(code);
  }

  async signOut(): Promise<void> {
    const client = this.checkSupabase();
    await client.auth.signOut();
  }
}

